import { render, staticRenderFns } from "./App.vue?vue&type=template&id=05f1a1ba&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=05f1a1ba&prod&lang=scss&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&id=05f1a1ba&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f1a1ba",
  null
  
)

export default component.exports